/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from '../transformer';

export default class Picture extends Transformer {
  /**
   * Method used to transform a fetched account
   *
   * @param user The fetched user
   *
   * @returns {Object} The transformed account
   */
  static fetch(picture) {
    return {
      id: picture.id,
      format: picture.format,
    };
  }
}
